import * as React from 'react'
import { ScrollView, Text, TouchableOpacity, View } from 'react-native'
import styled from '@theme/styled-components'

import Tag from '@components/tag/Tag'

import * as IncidentStore from '@store/incident/incident'
import useReducer from '@store/useReducer'

import useI18n from '@i18n/useI18n'

interface Props {
  items: IncidentStepScreen[]
  selected: IncidentStepScreen
  onItemSelected: (idx: IncidentStepScreen) => void
  onQuit: () => void
}

const BLACKLIST = ['START']
const TRANSFORM: Record<string, IncidentStepScreen> = { ACTIVITY_DETAIL: 'ACTIVITY' }

const Chapter = ({ items, selected, onItemSelected, onQuit }: Props) => {
  const i18n = useI18n()

  const completed = useReducer(IncidentStore.store, (s) => s.form.completed)

  // remove unused screens
  const data = items.filter((it) => !BLACKLIST.includes(it))

  // remove split from every level of activity
  const current = TRANSFORM[selected] || selected

  // current page index
  const selectedIdx = data.findIndex((it) => it === current)

  const renderItem = (item: IncidentStepScreen, index: number, list: IncidentStepScreen[]) => {
    const active = index < selectedIdx || completed
    const selected = index === selectedIdx

    return (
      <React.Fragment key={item}>
        <Item
          active={active || selected}
          disabled={!active}
          activeOpacity={0.8}
          key={item}
          onPress={() => onItemSelected(item)}>
          <ItemText selected={selected}>{`${index + 1} - ${i18n.t(`screens.incident.${item}.step`)}`}</ItemText>
        </Item>

        {index != list.length - 1 && <Separator />}
      </React.Fragment>
    )
  }

  return (
    <ScrollView>
      <Quit>
        <Tag
          activeColor
          focused
          item={{ label: i18n.t('screens.incident.quit'), value: 'tag' }}
          selected={false}
          leftIcon="close"
          onItemSelected={onQuit}
        />
      </Quit>

      {data.map(renderItem)}
    </ScrollView>
  )
}

export default Chapter

const Quit = styled(View)`
  margin: 24px;
  align-items: flex-start;
`

const Item = styled(TouchableOpacity)<{ active: boolean }>`
  padding: 24px;
  opacity: ${(props) => (props.active ? 1 : 0.5)};
`

const ItemText = styled(Text)<{ selected: boolean }>`
  ${(props) => props.theme.fonts.Headline};
  color: ${(props) => (props.selected ? props.theme.colors.primary : props.theme.colors.primaryText)};
  ${(props) => props.selected && `text-decoration: underline; text-decoration-color: ${props.theme.colors.primary};`};
`

const Separator = styled(View)`
  background-color: ${(props) => props.theme.colors.disable};
  height: 1px;
  margin: 0 24px;
`
